import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./ConnectedAdminChannelSelect'),
  name: 'AdminChannelSelect',
});
